import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class DelegateService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiUrl;

  constructor() {}

  getAllDelegate(id: string) {
    let params = new HttpParams();
    params = params.set("rinaId", id);
    return this.http.get(`${this.apiBaseUrl}/hr/delegations`, { params });
  }

  addDelegate(delegate: any) {
    return this.http.put(`${this.apiBaseUrl}/hr/create-delegation`, delegate);
  }

  deleteDelegate(rinaId: string, resourceDelegated: string) {
    return this.http.delete(
      `${this.apiBaseUrl}/hr/remove-delegation/${rinaId}/${resourceDelegated}`,
    );
  }
}
